import React from 'react'
import styles from './viewItem.module.sass'
import ItemInfo from './ItemInformation'
import { ToastContainer } from "react-toastify";

const ViewItem = ({isChanged, setIsChanged}) => {

  return (
    <>
      <ToastContainer />
      <div className={styles.row}>
        <div className={styles.col}>
            <ItemInfo isChanged={isChanged} setIsChanged={setIsChanged} className={styles.card}/>
        </div>
      </div>
    </>
  )
}

export default ViewItem